import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActiveSectionState, GuidedTourService } from '../../service/guided-tour.service';
import { Observable } from 'rxjs';
import { OA_ADMIN_AREA } from '../../model/guided-tour';
import { MyGroupsComponent } from './my-groups/my-groups.component';
import { ModalBridgeComponent } from '@markant-platform/shared/ui-modal';
import { SectionFinishDialogComponent } from '../../section-finish-dialog/section-finish-dialog.component';
import { AsyncPipe } from '@angular/common';
import { GeneralInformationComponent } from './general-information/general-information.component';
import { MyServicesComponent } from './my-services/my-services.component';
import { MyOrganizationComponent } from './my-organization/my-organization.component';
import { MyEmployeesComponent } from './my-employees/my-employees.component';

@Component({
  selector: 'markant-platform-oa-admin-area-guide',
  templateUrl: './admin-area-guide.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MyGroupsComponent,
    MyServicesComponent,
    ModalBridgeComponent,
    SectionFinishDialogComponent,
    AsyncPipe,
    GeneralInformationComponent,
    MyOrganizationComponent,
    MyEmployeesComponent,
  ],
})
export class OrganizationAdminAreaGuideComponent {
  protected readonly OA_ADMIN_AREA = OA_ADMIN_AREA;
  readonly activeSection$: Observable<ActiveSectionState | null>;
  readonly endDialogData$: Observable<ActiveSectionState | null>;

  constructor(guidedTourService: GuidedTourService) {
    this.activeSection$ = guidedTourService.activeSection$;
    this.endDialogData$ = guidedTourService.select(state => state.endDialog);
  }
}
